<template>
  <div>
    <el-card body-style="padding:10px">
      <span slot="header">种植计划</span>
      <div style="min-height: 603px">
        <el-form inline size="small">
          <el-form-item>
            <el-select
              v-model="filter.parkId"
              placeholder="根据园区查询"
              @change="selectPark"
              clearable
            >
              <el-option
                v-for="(item, index) in options.parks"
                :key="index"
                :label="item.name"
                :value="item.id"
              />
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-select
              v-model="filter.landId"
              placeholder="根据地块查询"
              clearable
            >
              <el-option
                v-for="(item, index) in options.lands"
                :key="index"
                :label="item.name"
                :value="item.id"
              />
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-select
              v-model="filter.varietyId"
              placeholder="根据草莓品种查询"
              clearable
            >
              <el-option
                v-for="(item, index) in options.varieties"
                :key="index"
                :label="item.name"
                :value="item.id"
              />
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-date-picker
              v-model="time"
              type="daterange"
              align="right"
              unlink-panels
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              :picker-options="pickerOptions"
            />
          </el-form-item>
          <el-form-item>
            <el-button type="primary" icon="el-icon-search" @click="search">
              搜索
            </el-button>
          </el-form-item>
        </el-form>
        <!-- 地块卡片列表 -->
        <el-row :gutter="6" style="min-height: 540px">
          <el-col :span="4" v-for="land in landsWithPlan" :key="land.id">
            <el-card
              body-style="padding: 4px; font-size: 13px"
              style="margin: 6px 0 0 0; line-height: 150%; color: #6f6f6f"
            >
              <el-row>
                <el-col>
                  <img src="./house.jpg" style="width: 100%; height: 120px" />
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="24">
                  <!-- 园区 -->
                  <i class="el-icon-map-location" />
                  {{ land.parkName }}
                </el-col>
                <el-col :span="24">
                  <!-- 地块 -->
                  <i class="el-icon-house" />
                  {{ land.landName }}
                </el-col>
              </el-row>
              <el-row v-if="land.planId" :gutter="20" style="height: 124px">
                <el-col :span="24">
                  计划起始：{{ new Date(land.begin).format('yyyy-MM-dd') }}
                </el-col>
                <el-col :span="24">
                  建议栽种：{{ new Date(land.plant).format('yyyy-MM-dd') }}
                </el-col>
                <el-col :span="24">
                  预期上市：{{ new Date(land.harvest).format('yyyy-MM-dd') }}
                </el-col>
                <el-col :span="24"> 品种：{{ land.variName }} </el-col>
                <el-col :span="12">种植：*/{{ land.days }}</el-col>
                <el-col :span="12">
                  阶段{{ land.phase + 1 }}/{{ land.phaseCount }}
                </el-col>
              </el-row>
              <el-row v-else style="color: #f00; height: 124px">
                <el-col>
                  <div>空闲</div>
                </el-col>
              </el-row>
              <el-row type="flex" justify="end">
                <el-tooltip effect="dark" content="查看详情" placement="top">
                  <el-button
                    icon="el-icon-info"
                    type="success"
                    circle
                    size="large"
                    style="padding: 4px"
                    @click="toDetailPage(land.landId)"
                  />
                </el-tooltip>
              </el-row>
            </el-card>
          </el-col>
        </el-row>
        <div style="margin-top: 12px; text-align: center">
          <el-pagination
            @current-change="pageChange"
            :current-page="filter.pageNum"
            :page-size="filter.pageSize"
            layout="total, prev, pager, next"
            :total="total"
          >
          </el-pagination>
        </div>
      </div>
    </el-card>
  </div>
</template>

<script>
import { getAllVarieties } from '@/api/variety2.js'
import { getParksInEnterprise } from '@/api/park2.js'
import { getLandInPark } from '@/api/land2.js'
import { getPlansOnLand } from '@/api/plan-list.js'
export default {
  name: 'Plant',
  data() {
    return {
      /**
       * 过滤条件
       */
      filter: {
        pageNum: 1,
        pageSize: 12,
        parkId: undefined,
        landId: undefined,
        varietyId: undefined,
        plantBegin: undefined,
        plantEnd: undefined,
      },
      /**
       * 过滤条件的日期
       */
      time: undefined,
      /**
       * 当前页地块列表（上面附带种植计划摘要信息），构成页面主体卡片列表
       */
      landsWithPlan: [],
      /**
       * 符合过滤条件的地块总数，用于分页显示
       */
      total: 0,
      /**
       * 下拉列表选项
       */
      options: {
        parks: [],
        lands: [],
        varieties: [],
      },
      /**
       * 日期选择框的快捷选项
       */
      pickerOptions: {
        shortcuts: [
          {
            text: '最近一周',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
              picker.$emit('pick', [start, end])
            },
          },
          {
            text: '最近一个月',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
              picker.$emit('pick', [start, end])
            },
          },
          {
            text: '最近三个月',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90)
              picker.$emit('pick', [start, end])
            },
          },
        ],
      },
    }
  },
  computed: {
    /**
     * 当前企业id
     */
    enterpriseId() {
      return this.$store.getters.currentEnterprise.id
    },
  },
  watch: {
    /**
     * 监听日期选择，刷新过滤条件对象
     */
    time: function (val, old) {
      console.log(val)
      this.filter.begin = val ? val[0].getTime() : undefined
      this.filter.end = val ? val[1].getTime() : undefined
    },
  },
  mounted() {
    // 初始化加载地块列表
    this.initOrRefreshPlans()
    // 初始化品种选项
    getAllVarieties().then((r) => {
      this.options.varieties = r.data.list
    })
  },
  methods: {
    /**
     * 选择园区查询地块
     */
    selectPark(id) {
      getLandInPark(id).then((r) => {
        console.log(r.data)
        this.options.lands = r.data
      })
    },
    /**
     * 点击“搜索”按钮，根据最新设置的条件刷新数据
     */
    search() {
      this.filter.pageNum = 1 // 重置页码，以免引起错误
      this.initOrRefreshPlans()
    },
    /**
     * 分页跳页，刷新数据
     */
    pageChange(page) {
      this.filter.pageNum = page
      this.initOrRefreshPlans()
    },
    /**
     * 初始化或刷新种植计划数据
     */
    initOrRefreshPlans() {
      getPlansOnLand(this.enterpriseId, this.filter).then((resp) => {
        console.log('plans on land = ', resp.data)
        const { list, total, pageNum } = resp.data
        this.landsWithPlan = list
        this.total = total
        this.filter.pageNum = pageNum
      })
    },
    /**
     * 跳转新建计划页面或查看详情页面
     */
    toDetailPage(landId) {
      this.$router.push(`/product/plan/detail/${landId}`)
    },
  },
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/product/plan/PlanList.vue